(function () {
    // 注册组件
    SR.component.extend('geography', geography);
    function geography() {
        if (SR.state.isNative && !SR.state.isDebug) {
            // init
            function getLocation() {
                var options = {};
                // 获取地理位置
                options.callback = function (code, param) {
                    if (code === 0) {
                        var geographyInfo = JSON.parse(param);
                        SR.data.location.longitude = geographyInfo.longitude;
                        SR.data.location.latitude = geographyInfo.latitude;
                    }
                }
                if (!SR.state.videoPlaying) {
                    upNativeComm.exec('Location.getLocation', options);
                }
            }
            getLocation();
            // 每 3 秒获取一次，2分钟后断开
            var getGeographyDataTimer = setInterval(function() {
                getLocation();
            }, 3000);
            setTimeout(function() {
                clearInterval(getGeographyDataTimer);
            }, 2 * 60 * 1000);
        } else {
            // H5 版显示段子
            if (SR.state.webGeography) {
                SR.data.location.longitude = 114.431045;
                SR.data.location.latitude = 30.448589;
            }
            // (function getLocation() {
            //     if (navigator.geolocation) {
            //         navigator.geolocation.getCurrentPosition(showPosition);
            //     }
            // }());

            // function showPosition(position) {
            //     // GPS坐标，即WGS-84坐标
            //     var longitude = position.coords.longitude;  //经度 lng
            //     var latitude = position.coords.latitude;    //纬度 lat
            //     // SR.data.location.longitude = gcj02[longitude];
            //     // SR.data.location.latitude = gcj02[latitude];
            // }
        }
    }
}());